app.service('account',function($global,html,console, callback, modal, localStorage, front, lastViewed, broker) {
	var user = {}; // informacje zwrócone z ajaxa
	var isLoad=false;
	var onLoadCallbacks=[];

	function showMessageForFrontUser(message) {
		modal.alert(message);
	}

	function checkUserNotifications() {
		if (user.activeInstalmentOrdersCount) {
			const notificationCount = user.activeInstalmentOrdersCount;
			$('#header #account-box .js-user-notifications-count').attr('aria-label', `Masz ${notificationCount} nowych powiadomień`).text(`${notificationCount}`);
		}
	}
	function setUserWatchedProductsCount(data){
		const $appWatchedButton = $('.js-app-bar-action-watched');
		if (!$appWatchedButton.length) {
			return;
		}
		const watchedProductsCount = data?.customerWatchedProductsCount || 0;
		if (data?.frontUserLogged === true) {
			if (watchedProductsCount > 0) {
				$appWatchedButton.attr('data-count', watchedProductsCount); // Aktualizacja licznika obserwowanych produktów
			}
		} else {
			// TODO: EUROMO-7331 pobrać dane z localStorage od Headless
		}
	}

	function getInfo() {
		return user;
	}

	function userLoggedSuccess(data) {
		user = data;
		setUserWatchedProductsCount(data);
		html.remove('user-not-logged user-logged');
		if (data.frontUserLogged === true) {
			html.add('user-logged');
			showLoginUserConfirmMessage();
			$('#account-box a').attr('href', '/konto.bhtml');
		} else {
			html.add('user-not-logged');
			setBackToUrl();
		}
		if (data.showMessageForFrontUser === true) {
			showMessageForFrontUser(data.messageForFrontUser);
		}
		checkUserNotifications();
		onLoadInit(data);
	}
	function onLoadInit(data){
		lastViewed.init();
		isLoad=true;
		callback.run('USER_DATA', $.extend({},data));
		for(var i=0;i<onLoadCallbacks.length;i++){
			var call=onLoadCallbacks.splice(0,1)[0];
			call($.extend({},data));
		}
	}
	function lastViewedProductId() {
		return $('#product-card').data('id') || 0;
	}
	function getAfterSearch() {
		var hash = window.location.hash;
		if (hash.match(/^#afterSearch-/)) {
			var value = hash.replace(/#afterSearch-/,"");
			var t = value.split('|');
			return {
				keyword : decodeURIComponent(t[0]),
				nodeid : t[1],
				searchType : t[2],
				nodeName : decodeURIComponent(t[3]),
				messageType : t[4]
			};
		}
		return false;
	}

	function getSearchData() {
		if (getAfterSearch() !== false) {
			return getAfterSearch();
		}
		else {
			return {
				keyword:$("#products").data('keyword') || undefined,
				searchType:$("#products").data('searchType') || undefined
			};
		}
	}
	function getUserData() {
		const $box = $('#hamburger, .js-app-bar-action-watched');
		if ($box.length) { // fix dla ścieżki
			var params = $.parseQuery(); // do przeniesienia
			var data=$.extend({
				from : params.from,
				lastViewedProductId : lastViewedProductId()
			},getSearchData());

			$.ajax({
				url : '/userData.ltr',
				dataType : 'json',
				cache : false,
				data : data,
				success : function(data, status, xhr) {
					userLoggedSuccess(data);
					broker.trigger('DATETIME_ONLOAD', [xhr.getResponseHeader('Date')]);
				},
				error : function(xhr, err) {
					broker.trigger('DATETIME_ONLOAD', [xhr.getResponseHeader('Date')]);
				}
			});
		} else {
			onLoadInit();
		}
	}

	function getCurrentPagePathWithParams() {
		return window.location.pathname + window.location.search;
	}
	function isPageExcludedFromRedirectBack(backToPath) {
		return backToPath.indexOf('.bhtml') === -1 || backToPath.indexOf('account-login.bhtml') === 1 || backToPath.indexOf('moje-konto.bhtml') === 1 || front.page() === 'error404' || front.page() === 'error403';
	}
	function resolveBackToPath(currentPage) {
		return currentPage.indexOf('/guest-') !== -1 ? '/' : currentPage;
	}
	function setBackToUrl() {
		const currentPage = getCurrentPagePathWithParams();
		if (!isPageExcludedFromRedirectBack(currentPage)) {
			const backToPath = encodeURIComponent(resolveBackToPath(currentPage));
			$('.js-back-to-page-after-login').attr('href', '/account-auth.bhtml?backTo=' + backToPath);
		}
	}
	function showLoginUserConfirmMessage() {
		const pagePathBeforeLogin = localStorage.getItem('pageBeforeLogin');
		const currentPagePathWithParams = getCurrentPagePathWithParams();
		$('#header #account-box a').removeClass('js-back-to-page-after-login');
		if (pagePathBeforeLogin == currentPagePathWithParams) {
			broker.trigger('GET_LOGIN_CONFIRMATION_MESSAGE');
			localStorage.removeItem('pageBeforeLogin');
		}
	}

	function setElements(){
		if(localStorage.getItem('watched-products-list-permissions-minimalize')){// warunek do usunięcia po jakimś czasie od wdrozenia zadania
			localStorage.setItem('permissions-minimalize', true);
			localStorage.removeItem('watched-products-list-permissions-minimalize');
		}
	}

	function onLoad(callback){
		if(isLoad){
			callback();
		}else{
			onLoadCallbacks.push(callback);
		}
	}
	function init() {
		setElements();
		getUserData();
		$('body').on('click', '.js-back-to-page-after-login', function(e) {
			localStorage.setItem('pageBeforeLogin', getCurrentPagePathWithParams());
		})
	}
	function isFrontUserLogged(reloadOnNotLogged = true) {
		console.log('SPRAWDZANIE ZALOGOWANIA...');
		var returnValue = false;
		$.ajax({
			url:'/front-user-logged.ltr',
			dataType:'json',
			async:false,
			success:function(data) {
				if(data.logged){
					console.log('UŻYTKOWNIK ZALOGOWANY');
					returnValue = true;
				}
				else {
					console.log('UŻYTKOWNIK NIEZALOGOWANY -> odświeżenie');
					if(reloadOnNotLogged){
						document.location.href=document.location.pathname;
					}
				}
			}
		});
		return returnValue;
	}

	$global('loggedUserInfo',getInfo);
	return {
		init : init,
		user : getInfo,
		reload: getUserData,
		isLoad : function(){
			return isLoad===true;
		},
		onLoad: onLoad,
		isFrontUserLogged:isFrontUserLogged
	};
});
